import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { CONTRACT_STATE_TEMPLATE_API } from "./apiRoutes";

interface UseGetStateLawsProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getStateLaws = async (data: any) =>
  await axiosAuth.post(`${CONTRACT_STATE_TEMPLATE_API}/grid`, data);

const useGetStateLaws = ({
  data,
  queryParams,
}: UseGetStateLawsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["contract-state-law"],
    queryFn: () => getStateLaws(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetStateLaws;
